import styled from 'styled-components';
import { CaptionRegularM } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const LinkCont = styled(CaptionRegularM)`
  font-size: 13px;
  line-height: 16px;
  text-decoration-line: underline;
  cursor: pointer;
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.primary[100]};
  `}
`;
